import { handleActions } from 'redux-actions';
import { CAPS } from '../constants';

const init = {
  elements: [],
};

const PLATFORMS_REQUIRE_DEV = ['custom'];

export default handleActions(
  {
    [CAPS.V2_PLATFORMS_GET]: (state, { error, payload: { data = [] } = {} }) => {
      if (error) {
        return state;
      }
      const platforms = data.map(({ id, ...p }) => ({
        id,
        requiresDevelopment: PLATFORMS_REQUIRE_DEV.includes(id),
        ...p,
      }));

      return {
        ...state,
        elements: platforms
          .sort(
            (
              { sortOrder: aSortOrder, key: aKey = '' },
              { sortOrder: bSortOrder, key: bKey = '' },
            ) => {
              if (aSortOrder - bSortOrder !== 0) {
                return aSortOrder - bSortOrder;
              } else {
                return aKey.localeCompare(bKey);
              }
            },
          )
          .map(({ sortOrder, ...p }) => p),
      };
    },
  },
  init,
);
